import {Component, Injector} from '@angular/core';
import {UtilsService} from "../../services/utils";
import {NgxSpinnerService} from "ngx-spinner";
import {Location} from "@angular/common";
import {NgxSmartModalService} from "ngx-smart-modal";
import * as moment from 'moment';
import {Router} from "@angular/router";
import Swal from "sweetalert2";

@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss']
})
export class BaseComponent {

    utils: UtilsService;
    spinner: NgxSpinnerService;
    location: Location;
    ngxSmartModalService: NgxSmartModalService;
    navigate: Router;

    constructor(protected injector: Injector) {
        this.spinner = injector.get(NgxSpinnerService);
        this.utils = injector.get(UtilsService);
        this.location = injector.get(Location);
        this.ngxSmartModalService = injector.get(NgxSmartModalService);
        this.navigate = injector.get(Router);
    }

    getUserType() {
        return (this.utils.getJwtUserGroup() || localStorage.getItem('wisper_userGroup')) ?? '';
    }

    formatDateForTable(date: string) {
        return this.utils.formatDateForTable(date);
    }

    formatPeriodForTable(startDate: string, endDate: string) {
        return this.utils.formatPeriodForTable(startDate, endDate);
    }

    isUUID(uuid: string) {
        const regex = '^[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12}$';
        const uuidRegex = new RegExp(regex);

        return uuidRegex.test(uuid)
    }

    showSpinner() {
        this.spinner.show();
    }

    hideSpinner() {
        this.spinner.hide();
    }

    formatDateInput(date: string){
        return moment(date).format('YYYY-MM-DD')
    }

    previousPage() {
        this.location.back();
    }

    goTo(path: string, params?: any){
        this.navigate.navigate([path], {queryParams: params})
    }

    getCurrentUser() {
        return this.utils.getCurrentUser();
    }

    hasPermission(permissionToCheck: string){
        let listOfPermissions = localStorage.getItem('wisper_permissions')?.split(',') ?? [];

        if (listOfPermissions && listOfPermissions.length === 0) return;

        return listOfPermissions.includes(permissionToCheck)
    }

    getLocalStorage(key: string){
        return localStorage.getItem(key)
    }

    showSuccessMessage(message: string){
        Swal.fire({
            icon: 'success',
            title: 'Perfetto!',
            text: message,
        })
    }

    showErrorMessage(message: string){
        Swal.fire({
            icon: 'error',
            title: "Errore",
            text: message,
        });
    }

    handleOnCloseModal(modalName: string) {
        this.ngxSmartModalService.resetModalData(modalName);
    }

    showInfoMessage(message: string, callback?: any){
        Swal.fire({
            icon: 'info',
            title: 'Informazione',
            text: message,
        }).then(r => {
            if (r.isConfirmed) {
                if (callback) callback();
            }
        })
    }

    showQuestionMessage(callback?: any) {
        return Swal.fire({
            icon: 'warning',
            title: "Sei sicuro? Non si potrà più tornare indietro",
            showCancelButton: true,
            confirmButtonText: "Si, procedi",
            cancelButtonText: "No, annulla"
        }).then((result) => {
            if (result.isConfirmed) {
                if (callback) {
                    callback();
                }
            }
            return result.isConfirmed;
        });
    }

    paymentTypes(athletePaymentRequest: any) {
        if (athletePaymentRequest === 'transfer') {
            return 'Bonifico bancario';
        } else if (athletePaymentRequest === 'localPayment') {
            return 'Pagamento in segreteria';
        } else if (athletePaymentRequest === 'nexi') {
            return 'Nexi';
        } else if (athletePaymentRequest === 'nexiRates') {
            return 'Rate mensili Nexi';
        } else {
            return 'Altro';
        }
    }

    translateStatus(status: string) {
        if (status === 'pendingPayment') return 'In attesa di pagamento';
        if (status === 'pendingApprovation') return 'In attesa di approvazione';
        if (status === 'active') return 'Attivo';
        if (status === 'approved') return 'Approvata';
        if (status === 'deleted') return 'Eliminato';
        if (status === 'pendingOtp') return 'In attesa di OTP';
        if (status === 'pendingOnboardingOtp') return 'OTP onboarding da confermare';
        if (status === 'pendingOnboarding') return 'Onboarding in corso';
        return status;
    }

    isSuperAdmin() {
        return this.utils.isSuperAdmin();
    }

    isAgent() {
        return this.utils.isAgent();
    }

    isEmpty(str: any) {
        return this.utils.isEmpty(str);
    }

}
